function clone(obj) {
    return structuredClone(obj);
}

export { clone };
//# sourceMappingURL=clone.js.map
